import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../css/pages/contactUs.scss";
import contactUsBg from "../assets/bg-contact-us.png";
import apiClient from "../api/clinet";
import { useCreateContactUs } from "../queries/contact-use";
interface Props {}
const ContactUs: React.FC<Props> = (Props) => {
  const [submitMessage, setSubmitMessage] = useState("");
  const { mutate, isSuccess, isError, isPending, reset } = useCreateContactUs();
  const initialValues = {
    name: "",
    subject: "",
    message: "",
    email: "",
    phoneNumber: "",
  };
  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .min(3, "اسم باید بیشتر از 2 حرف باشد")
      .max(20, "اسم باید کمتر از 20 حرف باشد")
      .required("وارد کردن این سطر الزامی است!"),
    subject: Yup.string()
      .max(30, "موضوع باید کمتر از 30 حرف باشد")
      .required("وارد کردن این سطر الزامی است!"),
    message: Yup.string()
      .min(4, "")
      .max(200, "متن پیام باید کمتر از 200 حرف باشد")
      .required("وارد کردن این سطر الزامی است!"),
    phoneNumber: Yup.number()
      .typeError("ورودی باید عدد باشد")

      .required("وارد کردن این سطر الزامی است!"),
    email: Yup.string()
      .email("فرمت ایمیل وارد شده درست نیست")
      .required("وارد کردن این سطر الزامی است!"),
  });

  interface ISubmitedData {
    name: string;
    subject: string;
    message: string;
    email: string;
    phoneNumber: string;
  }

  const onSubmit = async (data: ISubmitedData) => {
    setSubmitMessage("");
    mutate(data, {
      onSuccess: () => {
        setSubmitMessage("پیام شما با موفقیت ارسال شد");
      },
      onError: () => {
        setSubmitMessage("خطا در ارسال پیام، لطفا دوباره تلاش کنید");
      },
    });
  };

  return (
    <>
      <div className="new_home_web">
        <div className="responsive-container-block big-container">
          <img className="imgBG" src={contactUsBg} />
          <div className="responsive-container-block textContainer">
            <div className="topHead">
              <p className="text-blk heading">
                ارتباط با
                <span className="orangeText"> ما</span>
              </p>
              <div className="orangeLine" id="w-c-s-bgc_p-2-dm-id"></div>
            </div>
            <p className="text-blk subHeading">
              اگر سوالی دارید یا به کمک نیاز دارید، لطفاً با ما تماس بگیرید.
              <br />
              ما در اسرع وقت به شما پاسخ خواهیم داد.
            </p>
          </div>
          <div className="responsive-container-block container">
            <div
              className="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-7 wk-ipadp-10 line-container"
              id="i69b"
            >
              <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
              >
                <Form className="form-box">
                  {/* <form > */}
                  <div className="container-block form-wrapper">
                    <div className="responsive-container-block">
                      <div className="left4">
                        <div
                          className="responsive-cell-block wk-ipadp-6 wk-tab-12 wk-mobile-12 wk-desk-6"
                          id="i10mt-2"
                        >
                          <Field
                            type="text"
                            id="name"
                            name="name"
                            className="input"
                            placeholder="اسم"
                          />
                          <ErrorMessage name="name" component="div" />
                        </div>
                        <div className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                          <Field
                            type="text"
                            id="subject"
                            name="subject"
                            className="input"
                            placeholder="موضوع"
                          />
                          <ErrorMessage name="subject" component="div" />
                        </div>
                        <div className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12">
                          <Field
                            type="email"
                            name="email"
                            id="email"
                            className="input"
                            placeholder="ایمیل"
                          />
                          <ErrorMessage name="email" component="div" />
                        </div>
                        <div className="responsive-cell-block wk-desk-6 wk-ipadp-6 wk-tab-12 wk-mobile-12 lastPhone">
                          <Field
                            type="string"
                            name="phoneNumber"
                            id="phoneNumber"
                            className="input"
                            placeholder="شماره تماس"
                          />
                          <ErrorMessage name="phoneNumber" component="div" />
                        </div>
                      </div>
                      <div
                        className="responsive-cell-block wk-tab-12 wk-mobile-12 wk-desk-12 wk-ipadp-12"
                        id="i634i-2"
                      >
                        <Field
                          as="textarea"
                          id="message"
                          name="message"
                          className="textinput"
                          placeholder="متن پیام"
                        />
                        <ErrorMessage name="message" component="div" />
                      </div>
                    </div>
                    <button type="submit" className="send" disabled={isPending}>
                      ارسال
                    </button>
                    <div
                      className="successSubmitMessage"
                      style={{
                        display: submitMessage ? "block" : "none",
                      }}
                    >
                      {submitMessage}
                    </div>
                  </div>
                </Form>
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ContactUs;
